var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"title":_setup.fullCustomerLabel}},[_vm._v(" "+_vm._s(_setup.customerLabel)+" "),(_vm.showInactive && _setup.customer && _setup.customer.is_active !== true)?_c('span',{staticClass:"red--text text-caption ml-1"},[_vm._v(" Inactive ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }